var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoTelefono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3282 14.5526L14.713 13.1639C15.0957 12.7808 15.0957 12.1589 14.713 11.7753L11.9434 9.69231C11.4749 9.37434 10.9413 9.3092 10.5587 9.69231L9.71091 10.5425C8.86653 9.91232 7.94591 9.15576 7.09671 8.30414C6.13653 7.34106 5.26367 6.26991 4.54667 5.30684L5.36548 4.48513C5.7481 4.10202 5.68345 3.56692 5.36548 3.09647L3.2883 0.319192C2.96744 -0.146424 2.28615 -0.0643987 1.90352 0.319192L0.519208 1.70783C-0.246043 2.47501 -0.00093174 3.47236 0.519208 4.48513C0.519208 4.48513 2.235 7.55047 4.8521 10.1748C7.31383 12.6433 10.5587 14.5526 10.5587 14.5526C11.6506 14.9506 12.5635 15.3197 13.3282 14.5526Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTelefono);
export default __webpack_public_path__ + "static/media/icono_telefono.f197e33e3c12ee1f4aecec50f9238a34.svg";
export { ForwardRef as ReactComponent };